import axios from "axios";
import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getUserList = async (params) => {
  // const data = await apiCall("post", apiEndPoints.GETUSERLIST, params);
  const data = await apiCall("post", apiEndPoints.GETUSERFILTERDATA, params);
  return data;
};
const getUserDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETUSERDETAIL, params);
  return data;
};
const editUser = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITUSERPROFILE, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};

const getUserFilterDetail = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETUSERFILTERDATA, params);
  return data;
};
const createUser = async (params) => {
  const data = await apiCall("post", apiEndPoints.REGISTERANDADDUSER, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const userStatusUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.USERSTATUSUPDATE, params);
  return data;
};
const userPasswordGenrate = async (params) => {
  const data = await apiCall("post", apiEndPoints.USERPASSWORDSEND, params);
  return data;
};
const userRoleAndParentChange = async (params) => {
  const data = await apiCall(
    "post",
    apiEndPoints.USERROLEANDPARENTCHANGE,
    params
  );
  return data;
};
const ParentUserList = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETPARENTUSERLIST, params);
  return data;
};

const userDetailsForVisitor =  async (params) => {
  const data = await apiCall("post", apiEndPoints.USERDETAILSFORVISITOR, params);
  return data;
};

const userService = {
  getUserList,
  getUserDetail,
  getUserFilterDetail,
  createUser,
  editUser,
  userStatusUpdate,
  userPasswordGenrate,
  userRoleAndParentChange,
  ParentUserList,
  userDetailsForVisitor
};

export default userService;
